import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { md3 } from "vuetify/blueprints";

import { createVuetify } from "vuetify";

const haskoningLight = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#009EAB",
    secondary: "#009EAB",
    highlight: "#CCECEE",
    speckleColor: "#047EFB",
    error: "#D70C00",
    warning: "#E48C00",
    success: "#2AA18D",
  },
};

export default createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: "haskoningLight",
    themes: {
      haskoningLight: haskoningLight,
    },
  },
});
